import { render, staticRenderFns } from "./tableDetail.vue?vue&type=template&id=073af462&scoped=true&"
import script from "./tableDetail.vue?vue&type=script&lang=js&"
export * from "./tableDetail.vue?vue&type=script&lang=js&"
import style0 from "./tableDetail.vue?vue&type=style&index=0&id=073af462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073af462",
  null
  
)

export default component.exports